import { useState } from "react";
import { REJECT_REASONS } from "../lib/types";

interface Props {
  orderNumber: string;
  busy: boolean;
  onConfirm: (reasonCode: string, comment?: string) => void;
  onCancel: () => void;
}

// Ablehnung mit strukturiertem Grund (exakt die Backend-Whitelist) +
// Bestätigung (kein One-Click-Reject).
export function RejectDialog({ orderNumber, busy, onConfirm, onCancel }: Props) {
  const [reason, setReason] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const valid = REJECT_REASONS.some((r) => r.code === reason);

  return (
    <div className="dialog-backdrop" role="dialog" aria-modal="true" aria-label={`Bestellung ${orderNumber} ablehnen`}>
      <div className="dialog">
        <h2>Bestellung #{orderNumber} ablehnen</h2>
        <p>Grund wählen:</p>
        <div className="reason-list">
          {REJECT_REASONS.map((r) => (
            <label key={r.code} className={`reason ${reason === r.code ? "reason--active" : ""}`}>
              <input type="radio" name="reject-reason" value={r.code} checked={reason === r.code} onChange={() => setReason(r.code)} />
              <span>{r.label}</span>
            </label>
          ))}
        </div>
        <label className="field">
          <span>Kommentar (optional)</span>
          <input type="text" maxLength={300} value={comment} onChange={(e) => setComment(e.target.value)} />
        </label>
        <div className="dialog__actions">
          <button className="btn" onClick={onCancel} disabled={busy}>Abbrechen</button>
          <button className="btn btn--danger" onClick={() => onConfirm(reason, comment || undefined)} disabled={busy || !valid}>
            Ablehnen bestätigen
          </button>
        </div>
      </div>
    </div>
  );
}
